import { ControlledTextField } from 'modules/shared/components';

/**
 * InlineRejectSection
 *
 * Inline rejection UI that captures a mandatory textual reason
 * and exposes confirm / cancel actions.
 *
 * This component must be rendered within a react-hook-form FormProvider.
 *
 * Props:
 * @param {string} name - Form field name for the rejection reason.
 * @param {string} [label='Reason for rejection'] - Input label.
 * @param {Function} [onCancel] - Invoked when the cancel action is triggered.
 * @param {Function} onConfirm - Invoked when the confirm action is triggered.
 * @param {boolean} [disabled=false] - Disables input and actions when true.
 *
 * Notes:
 * - Validation rules are defined internally.
 * - `id` is derived from `name` for label association.
 */
export default function InlineRejectSection({
  name,
  label = 'Reason for rejection',
  onCancel = () => {},
  onConfirm = () => {},
  disabled = false,
}: { name: any; label?: string; onCancel?: () => void; onConfirm?: () => void; disabled?: any }) {
  return (
    <div className='row gap-3'>
      <ControlledTextField
        id={name}
        name={name}
        label={label}
        placeholder='Enter rejection reason'
        disabled={disabled}
        rules={{
          required: `${label} is required`,
          minLength: { value: 3, message: 'Minimum 3 characters required' },
          maxLength: { value: 300, message: 'Maximum 300 characters allowed' },
        }}
        orientation='row'
        showErrorInline
        fullWidth
      />
      <div className='row gap-3 self-end'>
        <button type='button' className='btn text-btn underline' onClick={onCancel}>
          Cancel
        </button>

        <button
          type='button'
          className='btn cta-outlined-btn'
          onClick={onConfirm}
          disabled={disabled}
        >
          Save
        </button>
      </div>
    </div>
  );
}
